import React from "react"
import Layout from "src/components/Layout"
import Card from "../../components/cards/Card"
import { Link } from "gatsby"

export default function Courses() {
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Select Course Language</h1>
        <div className="card_grid">
          <Link to="/courses/sinhala">
            <Card>
              <h1 className="heading">සිංහල</h1>
            </Card>
          </Link>
          {<Link to="/courses/tamil">
            <Card>
              <h1 className="heading" >தமிழ்</h1>
            </Card>
          </Link>}
          {/* <Link to="/courses/english">
            <Card>
              <h1>English</h1>
            </Card>
          </Link> */}
        </div>
      </div>
    </Layout>
  )
}
